module.exports = __webpack_public_path__ + "static/media/R-280HD_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/de/R-280HD_CrossSection.png
// module id = 470
// module chunks = 0